import { Injectable } from '@angular/core';
import { HomeFlexApiResponseModel } from '@core/models/DTOs/home-page-flex.dto';
import { HomeFlexModel, HomeModel } from '@models/home-page-flex';
import { Observable, forkJoin, of } from 'rxjs';
import { map, switchMap, tap, catchError } from 'rxjs/operators';
import { BaseRepository } from './base.repository';

@Injectable({
  providedIn: 'root'
})
export class HotelRepository extends BaseRepository {
  getAllSectionsData<TAccommodation = unknown, TSuggestedType = unknown>(
    accommodation: string,
    refresh = false
  ): Observable<HomeModel<TAccommodation, TSuggestedType>> {
    const url =
      this.baseUrl +
      (accommodation == 'hotel' ? 'v1/home/GetAllSections/1' :
        accommodation == 'special' ? 'v1/home/GetAllSections/5' : 'v1/accomodation/GetAllSections');
    return this.get<HomeFlexApiResponseModel<TAccommodation, TSuggestedType>>(url).pipe(
      map((res) => {
        const { Sections, AccomodationList, Statistics, SupportPhone, SuggestedTypes } = res;
        return { Sections, AccomodationList, Statistics, SupportPhone, SuggestedTypes };
      })
    );
  }

  getSectionById<T>(sectionQuery: string, refresh = false): Observable<T> {
    const url = this.baseUrl + `v1/accomodation/GetAccomodations/?${sectionQuery}`;
    return this.get<T>(url, refresh);
  }

  // A method that returns an object stream with the template type and the response as keys
  getSectionsData(refresh = false): Observable<any> {
    interface ApiResponse extends HomeFlexModel {
      TemplateType: number;
    }
    const url = this.baseUrl + 'home/GetAllSections';

    return this.get<HomeFlexModel[]>(url, refresh).pipe(
      switchMap((sections) => {
        return forkJoin(
          sections.map((section) => {
            return this.get(`${this.baseUrl}home/GetSection/${section.Id}`);
          })
        );
      })
    );
  }

  getSectionChainHotels() {
    const url = this.baseUrl + `home/GetChainHotels`;
    return this.get<any>(url);
  }


  getInternationalHotels() {
    return this.get(`${this.baseUrl}international-hotels`)
  }
  getChainHotelsGroupCode(code: string) {
    const url = this.baseUrl + `chainhotel/GetHotels?chainHotelsGroupCode=${code}`;
    return this.get<any>(url);
  }

  getReserveRooms(reserveId: string | number) {
    return this.get(
      `${this.baseUrl}UserProfile/GetReserveRooms/${reserveId}`
    ).pipe(
      map((data: any) => ({
        status: 200,
        data:
          Array.isArray(data) && data.length > 0
            ? data
            : data && Object.keys(data).length > 0
              ? data
              : 'empty'
      })),
      catchError(() =>
        of({
          status: null,
          data: 'empty'
        })
      )
    );
  }

  getActiveRooms(hotelId: string | number) {
    return this.get(
      `${this.baseUrl}hotelInfo/activeRooms/${hotelId}`
    ).pipe(
      map((data: any) => ({
        status: 200,
        data: Array.isArray(data) && data.length > 0 ? data : 'empty'
      })),
      catchError((err) =>
        of({
          status: err?.status ?? null,
          data: 'empty'
        })
      )
    );
  }
  getMaxExtraPersonCount(hotelId: string | number): Observable<any> {
    return this.http.get<any>(this.baseUrl + `hotelInfo/MaxExtraPersonCount/${hotelId}`);
  }
}
